// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1pOP8","signatureButtonsRight":"ModalSign_signatureButtonsRight__1zOyi"};